(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-tabs"] && !Shopify.designMode) return;
  try {
    class ProductTabs extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('[data-tab-button]');
      this.panels = this.querySelectorAll('[data-tab-panel]');
      this.init();
    }

    init() {
      // Set initial state - activate first tab
      const firstButton = this.buttons[0];
      const firstPanel = this.panels[0];
      
      if (firstButton && firstPanel) {
        firstButton.classList.add('product-tab__button--active');
        firstButton.setAttribute('aria-selected', 'true');
        firstButton.setAttribute('tabindex', '0');
        firstPanel.classList.add('product-tab__panel--active');
        firstPanel.hidden = false;
      }
      
      this.buttons.forEach(button => {
        button.addEventListener('click', this.handleTabClick.bind(this));
        button.addEventListener('keydown', this.handleKeydown.bind(this));
      });
    }

    handleTabClick(event) {
      const targetTab = event.currentTarget.dataset.tabButton;
      this.switchTab(targetTab);
    }

    handleKeydown(event) {
      const currentButton = event.currentTarget;
      const buttons = Array.from(this.buttons);
      const currentIndex = buttons.indexOf(currentButton);

      switch(event.key) {
        case 'ArrowLeft':
          event.preventDefault();
          const prevIndex = currentIndex === 0 ? buttons.length - 1 : currentIndex - 1;
          buttons[prevIndex].focus();
          this.switchTab(buttons[prevIndex].dataset.tabButton);
          break;
        case 'ArrowRight':
          event.preventDefault();
          const nextIndex = currentIndex === buttons.length - 1 ? 0 : currentIndex + 1;
          buttons[nextIndex].focus();
          this.switchTab(buttons[nextIndex].dataset.tabButton);
          break;
        case 'Home':
          event.preventDefault();
          buttons[0].focus();
          this.switchTab(buttons[0].dataset.tabButton);
          break;
        case 'End':
          event.preventDefault();
          buttons[buttons.length - 1].focus();
          this.switchTab(buttons[buttons.length - 1].dataset.tabButton);
          break;
      }
    }

    switchTab(targetTab) {
      this.buttons.forEach(button => {
        const isActive = button.dataset.tabButton === targetTab;
        button.classList.toggle('product-tab__button--active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
        button.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      this.panels.forEach(panel => {
        const isActive = panel.dataset.tabPanel === targetTab;
        panel.classList.toggle('product-tab__panel--active', isActive);
        panel.hidden = !isActive;
      });
    }
  }

  customElements.define('product-tabs', ProductTabs);
  } catch(e) { console.error(e); }
})();

})();
